shvenergy.skipheader = (function ($) {
    "use strict";

    function init() {
        $(".skip-header").on('click', (e) => {
            $("#main").attr("tabindex", "-1");
        });
    }

    init();

})(jQuery);